function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import WalletDb from "stores/WalletDb";
import Translate from "react-translate-component";
import Loadable from "react-loadable";
import LoadingIndicator from "./components/LoadingIndicator";
import { getWalletURL } from "./branding";
const Settings = Loadable({
  loader: () => import(
  /* webpackChunkName: "settings" */
  "./components/Settings/SettingsContainer"),
  loading: LoadingIndicator
});
export default class Deprecate extends React.Component {
  hasWallet() {
    return !!WalletDb.getWallet();
  }

  renderForWallet() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Translate, {
      content: "migration.text_1",
      component: "h4"
    }), /*#__PURE__*/React.createElement(Translate, {
      content: "migration.text_2",
      component: "p",
      unsafe: true,
      wallet_url: getWalletURL()
    }));
  }

  renderForCloud() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Translate, {
      content: "migration.text_3",
      unsafe: true,
      component: "p",
      wallet_url: getWalletURL()
    }));
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "grid-frame"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-block vertical",
      style: {
        paddingBottom: "3rem"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-content large-offset-2 large-8 shrink"
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "migration.title",
      component: "h2"
    }), /*#__PURE__*/React.createElement(Translate, {
      content: "migration.announcement_1",
      unsafe: true,
      component: "p"
    }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: getWalletURL(),
      target: "blank",
      rel: "noopener noreferrer"
    }, getWalletURL())), this.hasWallet() ? this.renderForWallet() : this.renderForCloud()), this.hasWallet() ? /*#__PURE__*/React.createElement(Settings, _extends({}, this.props, {
      deprecated: true
    })) : null));
  }

}